var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4884E8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.313 16.77c-1.544 0-2.905.736-3.76 1.856l-7.387-3.668c.123-.406.209-.826.209-1.27 0-.6-.127-1.172-.347-1.698l7.732-4.512c.86.979 2.125 1.614 3.552 1.614 2.585 0 4.688-2.04 4.688-4.546C25 2.04 22.897 0 20.312 0c-2.584 0-4.687 2.04-4.687 4.546 0 .578.123 1.126.326 1.635l-7.754 4.525c-.86-.95-2.107-1.563-3.51-1.563C2.103 9.143 0 11.182 0 13.689s2.103 4.546 4.688 4.546c1.569 0 2.952-.758 3.803-1.91l7.364 3.657c-.136.425-.23.867-.23 1.334 0 2.507 2.103 4.546 4.688 4.546 2.584 0 4.687-2.04 4.687-4.546 0-2.507-2.103-4.546-4.688-4.546z",
    transform: "translate(-1136.000000, -667.000000) translate(0.000000, 80.000000) translate(1112.000000, 567.000000) translate(0.000000, 8.000000) translate(24.000000, 12.000000) translate(4.000000, 3.000000)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.befbc2a6.svg";
export { ForwardRef as ReactComponent };